import React, { useEffect } from 'react';
import { Virtuoso } from 'react-virtuoso';
import { MCText, Spinner, View } from 'src/components/basic';
import { remCss } from 'src/components/mobile/utils';

import managersModel from '../managersModel';
import locationsModel from '../locationsModel';
import { SubLocation } from './Location';
import LANG_CONST from 'src/helpers/lang/const';

export const ContactTab = (props) => {
  const [isEmpty, setIsEmpty] = React.useState(
    managersModel.getListState('recent').items.length === 0
  );
  locationsModel.use();

  const emptyManager = React.useCallback((items) => {
    setIsEmpty(!items.length);
  }, []);

  useEffect(() => {
    managersModel.on('ClinicProfileManagersModel_refresh', emptyManager);
    return () => {
      managersModel.cancel('ClinicProfileManagersModel_refresh', emptyManager);
    };
  }, [emptyManager]);

  const items = locationsModel.items();
  const loading = locationsModel.refreshing();
  const noResults = locationsModel.noResults();
  const { manager } = locationsModel.state;

  if (!loading && !props.clinic?.id) {
    return (
      <View
        style={{
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'white'
        }}
      >
        <MCText label={LANG_CONST.text.no_results_yet} size={20} weight={500} textLight />
      </View>
    );
  }
  return (
    <View style={{ flex: 1, backgroundColor: 'white' }}>
      <Virtuoso
        data={items}
        components={{
          Header: () => (
            <View style={{ paddingHorizontal: remCss(30), paddingTop: remCss(15) }}>
              {noResults && !loading && props.clinic?.id && (
                <SubLocation {...props} emptyManagers={isEmpty} />
              )}
            </View>
          ),
          Footer: () => (
            <div style={{ textAlign: 'center', paddingBottom: 20, flex: 1 }}>
              {loading && <Spinner />}
            </div>
          )
        }}
        endReached={() => {
          if (locationsModel.hasMore() && !locationsModel.refreshing()) locationsModel.loadMore();
        }}
        itemContent={(index, item) => (
          <View
            style={{
              paddingBottom: remCss(40),
              paddingHorizontal: remCss(20)
            }}
            key={index}
          >
            <SubLocation location={item} {...props} manager={manager} emptyManagers={isEmpty} />
          </View>
        )}
      />
    </View>
  );
};
